import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { plainButtonVariants } from "./PlainButton.variants.js";
const textStyleIconSizes = {
    body1: '24',
    body2: '20',
    body3: '16',
    heading4: '24',
    heading5: '20',
    heading6: '16'
};
const PlainButton = /*#__PURE__*/ forwardRef(({ children, className, onClick, iconLeft, iconRight, loading, buttonType = 'button', slots = {
    buttonSlot: '',
    textSlot: '',
    iconSlot: ''
}, ...props }, ref)=>{
    const { buttonSlot, textSlot, iconSlot } = plainButtonVariants({
        ...props,
        disabled: props.disabled || loading
    });
    const classes = cn(buttonSlot(), className ?? slots.buttonSlot);
    const iconSlotClasses = cn(iconSlot(), slots.iconSlot);
    const textSlotClasses = cn(textSlot(), slots.textSlot);
    const iconSize = textStyleIconSizes[props.textStyle || 'body2'];
    return /*#__PURE__*/ jsxs("button", {
        ref: ref,
        type: buttonType,
        className: classes,
        onClick: onClick,
        ...cleanProps(props, [
            'type',
            'textStyle',
            'emphasis'
        ]),
        disabled: props.disabled || loading,
        "aria-busy": loading,
        children: [
            loading && /*#__PURE__*/ jsx(CdnIcon, {
                className: cn('animate-spin', iconSlotClasses),
                iconName: "refresh",
                size: iconSize
            }),
            iconLeft && !loading && /*#__PURE__*/ jsx(CdnIcon, {
                className: iconSlotClasses,
                iconName: iconLeft,
                size: iconSize
            }),
            /*#__PURE__*/ jsx("span", {
                className: textSlotClasses,
                children: children
            }),
            iconRight && /*#__PURE__*/ jsx(CdnIcon, {
                className: iconSlotClasses,
                iconName: iconRight,
                size: iconSize
            })
        ]
    });
});
export { PlainButton };
